
		import Async from 'preact-cli/async-component';

		function load(cb) {
			require.ensure([], function (require) {
				cb( require("!!../../../../../.local/lib/node_modules/preact-cli/node_modules/babel-loader/lib/index.js??ref--0!./index.js") );
			}, "route-projectDetails");
		}

		export default Async(load);
	


//////////////////
// WEBPACK FOOTER
// ./routes/projectDetails/index.js
// module id = l+xS
// module chunks = 17